<template>
  <div>
    <swiper :type="2"></swiper>
    <ground></ground>
    <leader></leader>
    <culture></culture>
    <organization></organization>
    <development></development>
    <honor></honor>
  </div>
</template>

<script>
import swiper from "./swiper";
import ground from "./about/ground";
import leader from "./about/leader";
import culture from "./about/culture";
import organization from "./about/organization";
import development from "./about/development";
import honor from "./about/honor";

export default {
  components: {
    ground,
    swiper,
    leader,
    culture,
    organization,
    development,
    honor
  }
};
</script>

